export const cartActionTypes = {
  TOGGLE_CART_HIDDEN: 'TOGGLE_CART_HIDDEN',
  ADD_ITEM: 'ADD_ITEM',
  CLEAR_ITEM_FROM_CART: 'REMOVE_ITEMS',
  DECREMENT_ITEM_QUANTITY: 'DECREMENT_ITEM_QUANTITY',
  CLEAR_CART: 'CLEAR_CART'
}